"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Noise_1 = __importDefault(require("../../classes/Noise"));
const getDefinables_1 = __importDefault(require("./getDefinables"));
const getNoises = () => {
    const noises = new Map;
    (0, getDefinables_1.default)("Noise").forEach((noise) => {
        const slug = noise.slug;
        if (noise instanceof Noise_1.default) {
            noises.set(slug, noise);
        }
    });
    return noises;
};
exports.default = getNoises;
